import { AccountAddress } from '@aptos-labs/ts-sdk'

export const isValidAptosAddress = (address?: string): boolean => {
  try {
    const { valid } = AccountAddress.isValid({ input: address })
    return valid
  } catch (error) {
    // If any error occurs during validation, return false
    return false
  }
}
